import React, { useState, useEffect } from 'react';
import { getOrCreateCustomer, addProduct, addPetPerson, linkCustomerProductPetPerson, getExistingPetsPeople, checkImagesExistence } from '../dbOperations';
import { readAndCompressImage } from 'browser-image-resizer';
// import piexif from 'piexifjs';
import heic2any from 'heic2any';
// import styled from 'styled-components';



const getResizeConfig = async (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectURL = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(objectURL);
      const longestSide = Math.max(img.width, img.height);
      let maxSize;

      if (longestSide > 1024) {
        maxSize = 1024;
      } else if (longestSide > 640) {
        maxSize = 640;
      } else {
        maxSize = longestSide;
      }

      const config = {
        quality: 0.5,
        maxWidth: maxSize,
        maxHeight: maxSize,
        debug: true,
        autoRotate: true,
      };
      resolve(config);
    };
    
    img.onerror = (error) => {
      URL.revokeObjectURL(objectURL);
      reject(`Image load error: ${error}`);
    };

    img.src = objectURL;
  });
};

const blobToBase64 = (blob) => {
  const reader = new FileReader();
  return new Promise((resolve) => {
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

function ProductCustomizer() {
  // const [sessionId, setSessionId] = useState('');
  // const [sessionId, setSessionId] = useState('');

  const [customerId, setCustomerId] = useState(null);
  const [productType, setProductType] = useState('');
  const [customizationInfo, setCustomizationInfo] = useState('');
  const [petPersonName, setPetPersonName] = useState('');
  const [petPersonBirthdate, setPetPersonBirthdate] = useState('');
  const [petPersonImages, setPetPersonImages] = useState([]);
  const [setPreviewImages] = useState([]);
  const [existingPetsPeople, setExistingPetsPeople] = useState([]);
  const [selectedPetPerson, setSelectedPetPerson] = useState('');
  const [error, setError] = useState(null);
  const [processedImages, setProcessedImages] = useState([]);
  const [hasDuplicates, setHasDuplicates] = useState(false);
  const [hasExistingImages, setHasExistingImages] = useState(false);
  const [existingDbImages, setExistingDbImages] = useState([]);

  const [vips, setVips] = useState(null);
  const [analysisResults, setAnalysisResults] = useState({});
  const [analysisStatus, setAnalysisStatus] = useState('');
  const [overallAnalysisTime, setOverallAnalysisTime] = useState(null);
  const [individualAnalysisTimes, setIndividualAnalysisTimes] = useState({});



  useEffect(() => {
    const storedSessionId = localStorage.getItem('sessionId') || Date.now().toString();
    // setSessionId(storedSessionId);
    localStorage.setItem('sessionId', storedSessionId);

    getOrCreateCustomer(storedSessionId).then(customer => setCustomerId(customer.id));
    getExistingPetsPeople().then(setExistingPetsPeople);
    initVips();

  }, []);


  async function initVips() {
    try {
      if (typeof window.SharedArrayBuffer === "undefined") {
        setAnalysisStatus('Vips module cannot be loaded: SharedArrayBuffer is not available in this environment.');
        return;
      }
      const startTime = performance.now();
      const Vips = await window.Vips();
      const endTime = performance.now();
      setVips(Vips);
      setAnalysisStatus(`Vips module loaded in ${(endTime - startTime).toFixed(2)} ms`);
    } catch (error) {
      setAnalysisStatus('Failed to load Vips module. Please refresh the page.');
    }
  }

  const handleAddToCart = async (e) => {
    e.preventDefault();

    try {
      let petPersonId;

      if (selectedPetPerson === 'new') {
        petPersonId = await addPetPerson({
          name: petPersonName,
          birthdate: petPersonBirthdate,
          images: petPersonImages
        });
      } else {
        petPersonId = selectedPetPerson;
      }

      const productId = await addProduct(customerId, {
        productType,
        customizationInfo
      });

      await linkCustomerProductPetPerson(customerId, productId, petPersonId);

      // Reset form
      setProductType('');
      setCustomizationInfo('');
      setPetPersonName('');
      setPetPersonBirthdate('');
      setPetPersonImages([]);
      setPreviewImages([]);
      setSelectedPetPerson('');
      setProcessedImages([]);
      setHasDuplicates(false);
      setHasExistingImages(false);
      setExistingDbImages([]);

      // Refresh existing pets/people list
      getExistingPetsPeople().then(setExistingPetsPeople);
    } catch (error) {
      console.error('Error adding to cart:', error);
      setError('Error adding to cart, please try again.');
    }
  };

  const handleImageChange = async (e) => {
    try {
      const files = Array.from(e.target.files);
      const newProcessedImages = [];
      const overallStartTime = performance.now();

      for (const file of files) {
        let convertedFile = file;

        // Convert HEIC to JPEG if necessary
        if (file.type === 'image/heic' || file.name.endsWith('.heic')) {
          try {
            const convertedBlob = await heic2any({ blob: file, toType: 'image/jpeg' });
            convertedFile = new File([convertedBlob], file.name.replace(/\.[^/.]+$/, ".jpg"), { type: 'image/jpeg' });
          } catch (error) {
            console.error('Error converting HEIC to JPEG:', error);
            continue;
          }
        }

        // Convert image to JPEG and remove EXIF data
        const canvas = document.createElement('canvas');
        const img = new Image();
        const objectURL = URL.createObjectURL(convertedFile);

        await new Promise((resolve, reject) => {
          img.onload = () => {
            try {
              URL.revokeObjectURL(objectURL);
              canvas.width = img.width;
              canvas.height = img.height;
              const ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0);
              resolve();
            } catch (error) {
              reject(`Canvas drawing error: ${error}`);
            }
          };
          img.onerror = (error) => {
            URL.revokeObjectURL(objectURL);
            reject(`Image load error: ${error}`);
          };
          img.src = objectURL;
        });

        const dataURL = canvas.toDataURL('image/jpeg', 1.0);
        const jpegBlob = await fetch(dataURL).then(res => res.blob());

        // Remove EXIF data
        const reader = new FileReader();
        reader.readAsDataURL(jpegBlob);
        // const fileBase64 = await new Promise((resolve) => {
        //   reader.onload = () => resolve(reader.result);
        // });

        // const strippedBase64 = piexif.remove(fileBase64);

        // Resize the image
        const config = await getResizeConfig(jpegBlob);
        const resizedBlob = await readAndCompressImage(jpegBlob, config);
        const resizedBase64 = await blobToBase64(resizedBlob);

        if (vips) {
          const analysisStartTime = performance.now();
          const imageAnalysisResults = await processImage(resizedBlob);
          const analysisEndTime = performance.now();
          const analysisTime = analysisEndTime - analysisStartTime;

          setAnalysisResults(prev => ({ ...prev, [file.name]: imageAnalysisResults }));
          setIndividualAnalysisTimes(prev => ({ ...prev, [file.name]: analysisTime }));
        }


        newProcessedImages.push({
          name: convertedFile.name,
          base64: resizedBase64,
          isDuplicate: false,
          existsInDb: false
        });
      }

      // Check for duplicates within the current batch
      const updatedProcessedImages = [...processedImages, ...newProcessedImages].map((img, index, array) => ({
        ...img,
        isDuplicate: array.some((otherImg, otherIndex) => 
          index !== otherIndex && img.base64 === otherImg.base64
        )
      }));

      // Check for existence in IndexedDB
      const base64Images = updatedProcessedImages.map(img => img.base64);
      const existenceCheck = await checkImagesExistence(base64Images);

      const finalProcessedImages = updatedProcessedImages.map((img, index) => ({
        ...img,
        existsInDb: existenceCheck[index].exists
      }));

      const duplicatesExist = finalProcessedImages.some(img => img.isDuplicate);
      const existingImagesExist = finalProcessedImages.some(img => img.existsInDb);
      setHasDuplicates(duplicatesExist);
      setHasExistingImages(existingImagesExist);

      setProcessedImages(finalProcessedImages);
      setPetPersonImages(finalProcessedImages.filter(img => !img.existsInDb).map(img => img.base64));
      setPreviewImages(finalProcessedImages.map(img => img.base64));
      setExistingDbImages(finalProcessedImages.filter(img => img.existsInDb));


      const overallEndTime = performance.now();
      setOverallAnalysisTime(overallEndTime - overallStartTime);

      setAnalysisStatus('Image analysis complete');

    } catch (error) {
      console.error('Error processing images:', error);
      setError('Error processing images, please try again.');
    }
  };
  async function processImage(blob) {
    const functions = [
      'check_saturation',
      'check_odd_aspect_ratio',
      'check_vignette',
      'check_sepia_filter',
      'check_red_filter',
      'check_noise',
      'check_monochrome',
      'check_contrast',
      'check_blur',
      'check_8bit'
    ];

    const results = {};
    const arrayBuffer = await blob.arrayBuffer();

    for (const func of functions) {
      try {
        const Vips = await window.Vips(); // Reinitialize for each function call
        const path = '/tmp/image.jpg';
        Vips.FS.writeFile(path, new Uint8Array(arrayBuffer));
        
        if (typeof Vips[`_${func}`] !== 'function') {
          console.warn(`${func} function is not available`);
          continue;
        }

        const result = Vips.ccall(
          func,
          'number',
          ['string'],
          [path]
        );
        
        results[func] = result;

        Vips.FS.unlink(path);
        if (typeof Vips._cleanup_vips === 'function') {
          Vips._cleanup_vips();
        }
        
        await new Promise(resolve => setTimeout(resolve, 100));
      } catch (error) {
        console.error(`Error in ${func}:`, error);
        results[func] = 'Error';
      }
    }

    return results;
  }

  const formatTestName = (test) => {
    return test.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  const formatResult = (result) => {
    if (result === 'Error') return 'Error occurred';
    switch (result) {
      case 0: return 'Normal';
      case 414: return 'Detected';
      default: return `Unknown (${result})`;
    }
  };



  const removeImage = (index) => {
    const updatedImages = processedImages.filter((_, i) => i !== index);
    const updatedProcessedImages = updatedImages.map(img => ({
      ...img,
      isDuplicate: updatedImages.some(otherImg => 
        img !== otherImg && img.base64 === otherImg.base64
      )
    }));

    const duplicatesExist = updatedProcessedImages.some(img => img.isDuplicate);
    const existingImagesExist = updatedProcessedImages.some(img => img.existsInDb);
    setHasDuplicates(duplicatesExist);
    setHasExistingImages(existingImagesExist);

    setProcessedImages(updatedProcessedImages);
    setPetPersonImages(updatedProcessedImages.filter(img => !img.existsInDb).map(img => img.base64));
    setPreviewImages(updatedProcessedImages.map(img => img.base64));
    setExistingDbImages(updatedProcessedImages.filter(img => img.existsInDb));
  };

  const hasNewImages = processedImages.some(img => !img.existsInDb);

  return (
    <form onSubmit={handleAddToCart}>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <select value={productType} onChange={(e) => setProductType(e.target.value)} required>
        <option value="">Select Product Type</option>
        <option value="pillow">Pillow</option>
        <option value="mug">Mug</option>
        <option value="tshirt">T-Shirt</option>
      </select>

      <textarea 
        value={customizationInfo} 
        onChange={(e) => setCustomizationInfo(e.target.value)} 
        placeholder="Customization Info"
        required
      />

      <select 
        value={selectedPetPerson} 
        onChange={(e) => setSelectedPetPerson(e.target.value)}
        required
      >
        <option value="">Select Pet/Person</option>
        {existingPetsPeople.map(pp => (
          <option key={pp.id} value={pp.id}>{pp.name}</option>
        ))}
        <option value="new">Add New Pet/Person</option>
      </select>

      {selectedPetPerson === 'new' && (
        <>
          <input 
            type="text" 
            value={petPersonName} 
            onChange={(e) => setPetPersonName(e.target.value)} 
            placeholder="Pet/Person Name" 
            required 
          />
          <input 
            type="date" 
            value={petPersonBirthdate} 
            onChange={(e) => setPetPersonBirthdate(e.target.value)} 
            required 
          />
          <input 
            type="file" 
            onChange={handleImageChange} 
            multiple 
            required 
          />
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {processedImages.map((img, index) => (
              <div key={index} style={{ 
                position: 'relative', 
                margin: '10px',
                border: img.isDuplicate && img.existsInDb ? '3px solid purple' :
                        img.isDuplicate ? '3px solid red' :
                        img.existsInDb ? '3px solid green' : 'none',
                padding: '5px'
              }}>
                <img 
                  src={img.base64} 
                  alt={`Preview ${index}`} 
                  style={{ maxWidth: '200px', maxHeight: '200px' }} 
                />
                <button 
                  type="button" 
                  onClick={() => removeImage(index)}
                  style={{
                    position: 'absolute',
                    top: '5px',
                    right: '5px',
                    background: 'red',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '20px',
                    height: '20px',
                    cursor: 'pointer'
                  }}
                >
                  X
                </button>
                {(img.isDuplicate || img.existsInDb) && (
                  <span style={{
                    position: 'absolute',
                    bottom: '5px',
                    left: '5px',
                    background: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    padding: '2px 5px',
                    fontSize: '12px'
                  }}>
                    {img.isDuplicate && img.existsInDb ? 'Duplicate & In DB' :
                     img.isDuplicate ? 'Duplicate' : 'In DB'}
                  </span>
                )}

{analysisResults[img.name] && (

<div style={{ marginTop: '10px' }}>
<h4>Analysis Results:</h4>
<ul style={{ fontSize: '12px', padding: '0 0 0 20px' }}>
  {Object.entries(analysisResults[img.name]).map(([test, result]) => (
    <li key={test}>
      {formatTestName(test)}: {formatResult(result)}
    </li>
  ))}
</ul>

<p style={{ fontSize: '12px' }}>
                      Analysis Time: {individualAnalysisTimes[img.name]?.toFixed(2)} ms
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      <button 
        type="submit" 
        disabled={hasDuplicates || !hasNewImages || !productType || !customizationInfo || 
                  (selectedPetPerson === 'new' && (!petPersonName || !petPersonBirthdate || processedImages.length === 0))}
      >
        Add to Cart
      </button>

      {hasExistingImages && (
        <div>
          <p>The following images already exist in the database and will not be uploaded again:</p>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {existingDbImages.map((img, index) => (
              <div key={index} style={{ margin: '5px' }}>
                <img 
                  src={img.base64} 
                  alt={`Existing ${index}`} 
                  style={{ maxWidth: '100px', maxHeight: '100px', border: '2px solid green' }} 
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {hasDuplicates && (
        <p style={{ color: 'red' }}>
          Please remove duplicate images before adding to cart.
        </p>
      )}

{overallAnalysisTime && (
        <p>Total image analysis time: {overallAnalysisTime.toFixed(2)} ms</p>
      )}

      <p>{analysisStatus}</p>

    </form>
  );
}

export default ProductCustomizer;